module.exports = __webpack_public_path__ + "static/logo19-0f9bd73c4eda3fca745c318c5d65dcdd.png";